import React from 'react'
import {Cultura} from "../components/lineamientos/Cultura";

export const CulturaPage = () => {
    return (
        <Cultura/>
    )
}
